<template>
  <page-layout
    :title="organization ? organization.name : ''"
    :text="organization ? organization.tagline: ''"
    button-text="Find Housing"
    :media="media"
    :socials="socials"
    :loaded="organizationLoaded"
    @action="scrollToPortfolio"
  >
    <template v-if="organization">
      <properties-portfolio
        v-if="getBlockVisibility('discover-you-new-home') || getBlockVisibility('featured-locations')"
        id="properties"
        :blocks-visibility="{
          'discover-you-new-home': getBlockVisibility('discover-you-new-home'),
          'featured-locations': getBlockVisibility('featured-locations')
        }"
      />
      <organization-about
        v-if="getBlockVisibility('about')"
        :title="organization.name"
        :text="organization.description"
      />
      <testimonials-carousel
        v-if="getBlockVisibility('what-people-say-about-us')"
        :organization-id="`${organization.id}`"
      />
      <contact-form
        v-if="organization.id && getBlockVisibility('have-a-question?-please-ask-us')"
        :contact-data="organization"
      />
    </template>
  </page-layout>
</template>

<script lang="ts">
import { Vue, Component, Watch, Emit } from 'vue-facing-decorator'

import InstagramWidget from '@/components/common/InstagramWidget.vue'
import TestimonialsCarousel from '@/components/common/TestimonialsCarousel.vue'
import PageLayout from '@/components/common/PageLayout.vue'

import PropertiesPortfolio from '@/components/landing/PropertiesPortfolio.vue'
import OrganizationAbout from '@/components/landing/OrganizationAbout.vue'
import ContactForm from '@/components/landing/ContactForm.vue'

const namespace: string = 'organization'

@Component({
  components: {
    PageLayout,
    InstagramWidget,
    TestimonialsCarousel,
    OrganizationAbout,
    PropertiesPortfolio,
    ContactForm,
  },
})

export default class Home extends Vue {
  get organization () {
    return this.$store.getters[`${namespace}/organization`]
  }

  get organizationLoaded () {
    return this.$store.getters[`${namespace}/organizationLoaded`]
  }

  @Emit('action')
  scrollToPortfolio () {
    const properties = document.getElementById('properties')
    if (!properties) return

    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: properties.offsetTop - 50,
    })
  }

  @Watch('organizationLoaded')
  onOrganizationLoad () {
    if (this.organization && this.organization.properties.length === 1) {
      this.$router.push({ name: 'Property', params: { id: this.organization.properties[0].id } })
    }
    if (this.organization && !this.organization.serve_new_site) {
      window.location.href = '/home'
      // Disabled on local build because we don't have nginx.
      if (process.env.NODE_ENV !== 'development') {
        window.location.href = '/home'
      }
    }
    this.setTitle()
  }

  setTitle () {
    if (this.organization) {
      document.title = 'Room Choice | ' + this.organization.name
    }
  }

  get media () {
    return this.organization
      ? this.organization.background_media.sort((a, b) => a.order - b.order).map(i => i.file)
      : []
  }

  get socials () {
    return this.organization
      ? [
          { type: 'facebook', icon: 'facebook', link: this.organization.facebook },
          { type: 'twitter', icon: 'twitter', link: this.organization.twitter },
          { type: 'instagram', icon: 'instagram', link: this.organization.instagram },
        ].filter(({ link }) => link)
      : []
  }

  getBlockVisibility (name: string) {
    const attr = this.organization.website_block_attrs.find(attr => attr.block_name === name)
    return attr ? attr.visibility : true
  }

  getBlockDescription (name: string) {
    const attr = this.organization.website_block_attrs.find(attr => attr.block_name === name)
    return attr ? attr.description : ''
  }

  mounted () {
    this.setTitle()
  }
}
</script>

<style lang="scss"></style>
